import React, { useState } from 'react';
import { ArrowLeft, ShoppingBag, Swords } from 'lucide-react';
import { PetInventory } from './inventory/PetInventory';
import { ItemInventory } from './inventory/ItemInventory';
import type { User } from '../../types/user';

interface InventoryProps {
  onBack: () => void;
  user: User | null;
}

export function Inventory({ onBack, user }: InventoryProps) {
  const [activeTab, setActiveTab] = React.useState<'pets' | 'items'>('pets');
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">Please log in to view your inventory</p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex gap-4 mb-8">
        <button
          onClick={() => setActiveTab('pets')}
          className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-serif
            ${activeTab === 'pets' 
              ? 'bg-gradient-to-r from-yellow-600 to-amber-500 text-white' 
              : 'bg-gray-800 text-amber-200 hover:bg-gray-700'}`}
        >
          <Swords className="w-5 h-5" />
          Battle Pets
        </button>
        <button
          onClick={() => setActiveTab('items')}
          className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 rounded-lg font-serif
            ${activeTab === 'items'
              ? 'bg-gradient-to-r from-yellow-600 to-amber-500 text-white'
              : 'bg-gray-800 text-amber-200 hover:bg-gray-700'}`}
        >
          <ShoppingBag className="w-5 h-5" />
          Items
        </button>
      </div>

      {activeTab === 'pets' ? (
        <PetInventory user={user} />
      ) : (
        <ItemInventory user={user} />
      )}
    </div>
  );
}